import React from "react";

export const FlowContainer = (props) => {
  return (
    <div className="p-0 w-100  flow-container">
      {React.createElement(props.Element, props.role)}
    </div>
  );
};
